import { Component } from '@angular/core';

import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false
})
export class LoaderComponent {
  showLoader = false;

  constructor(private loaderService: LoaderService) {
    this.loaderService.getLoader().subscribe((state) => {
      this.showLoader = state;
    });
  }
}
